import { render, staticRenderFns } from "./OrderItemMenuPromoProduct.vue?vue&type=template&id=2324ce2d&scoped=true&"
import script from "./OrderItemMenuPromoProduct.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenuPromoProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemMenuPromoProduct.vue?vue&type=style&index=0&id=2324ce2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324ce2d",
  null
  
)

export default component.exports